import React, { Component } from "react";

import { Col, Row } from "react-flexbox-grid";
import { BarChart, Card, DoughnutChart } from "ui-kit-ck-consultant";

import {colors} from "../../utils/colors";

const round2 = (value) =>
  typeof value === "number" ? Math.round(value * 100) / 100 : value;

export class CardPerf extends Component {
  render() {
    return (
      <Card
        title={`${this.props.NGRA} performance ${this.props.type}`}
        className="mb-10 mb-30-xl"
        isLoader={this.props.isLoad}
      >
        <Row>
          {this.props.data !== undefined && this.props.byMonth ? (
            <>
              <Col mdOffset={1} xs={12} md={12} lg={3}>
                <DoughnutChart
                  className={`mt-30`}
                  max={this.props.max}
                  unit={this.props.unit ? this.props.unit : "%"}
                  number={round2(this.props.data)}
                  text={
                    this.props.doughnutText
                      ? this.props.doughnutText
                      : `Performance ${this.props.type} du jour`
                  }
                />
              </Col>
              <Col xs={12} md={12} lg={8}>
                <BarChart
                  title={`Performance ${this.props.type}`}
                  dataSet={
                    this.props.dataSet
                      ? this.props.dataSet
                      : [
                          {
                            type: "line",
                            label: `Evolution ${this.props.type} (%)`,
                            data: this.props.evol,
                            color: colors.red[0],
                          },
                          {
                            type: "line",
                            label: `Performance ${this.props.type}`,
                            data: this.props.byMonth,
                            color: colors.blue[0],
                          },
                          {
                            type: "line",
                            label: `Performance ${this.props.type} (N-1)`,
                            data: this.props.byMonthYearBefore,
                            color: colors.green[0],
                          },
                        ]
                  }
                  isLegend={this.props.isLegend}
                  xAxes={this.props.xAxes}
                  yAxes={this.props.yAxes}
                  widthBar={15}
                />
              </Col>
            </>
          ) : null}
        </Row>
      </Card>
    );
  }
}

export default CardPerf;
